import React from 'react';
import { IIconProps } from './utils';

export const Restart = ({
  fill = 'currentColor', height = 16, width = 16, ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 16 16" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <g clipPath="url(#clip0_254_2401)">
      <rect fill="none" height={height} width={width} />
      <path
        d="M11.0943 12.245C8.70902 13.9723 5.38986 13.472 3.68078 11.1276C3.36643 10.6964 3.12845 10.2328 2.96421 9.75263M11.0943 12.245L10.7882 14.0881M11.0943 12.245L9.31747 11.5049M4.90521 3.75508C7.29052 2.0278 10.6097 2.52809 12.3188 4.87252C13.4642 6.44376 13.5957 8.44456 12.8398 10.1134M4.90521 3.75508L5.21132 1.91196M4.90521 3.75508L6.68207 4.49522M3.15971 5.88674C2.99869 6.24223 2.87794 6.61279 2.79868 6.99105"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
    </g>
    <defs>
      <clipPath id="clip0_254_2401">
        <rect fill="none" height={height} width={width} />
      </clipPath>
    </defs>
  </svg>
);
